import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Calendar
} from 'react-big-calendar'
import {
  Table
} from 'react-lib/frameworks/Table'
import {
  FormGroup,
  FormField,
  Dropdown,
  Checkbox,
  Button
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardAppointmentSummaryUX = (props: any) => {
    return(
      <div
        id="CardAppointmentSummaryUX-div-0"
        style={{height: "90vh", display: "flex"}}>
        <div
          id="CardAppointmentSummaryUX-div-2"
          style={{flex: 1, overflow: "auto"}}>
          
          <div
            className="ui form"
            id="CardAppointmentSummaryUX-div-44"
            style={{padding: "10px"}}>
            
            <FormGroup
              id="CardAppointmentSummaryUX-FormGroup-45"
              inline={true}>
              <FormField
                id="CardAppointmentSummaryUX-FormField-46"
                style={{display: "block"}}
                width="8">
                <label
                  id="CardAppointmentSummaryUX-label-57">
                  {props.languageUX === "en" ? "Appointment Type" : "ประเภทนัดหมาย"}
                </label>
                <div
                  id="CardAppointmentSummaryUX-div-64">
                  
                  <Dropdown
                    clearable={true}
                    fluid={true}
                    id="CardAppointmentSummaryUX-Dropdown-71"
                    onChange={props.onChange("appointmentType")}
                    options={props.appointmentTypeOptions}
                    selection={true}
                    value={props.appointmentType}>
                  </Dropdown>
                </div>
              </FormField>
              <FormField
                id="CardAppointmentSummaryUX-FormField-47"
                style={{display: "block"}}
                width="8">
                <label
                  id="CardAppointmentSummaryUX-label-58">
                  {props.languageUX === "en" ? "Appointment status" : "สถานะนัดหมาย"}
                </label>
                <div
                  id="CardAppointmentSummaryUX-div-65">
                  
                  <Dropdown
                    clearable={true}
                    fluid={true}
                    id="CardAppointmentSummaryUX-Dropdown-72"
                    onChange={props.onChange("appointmentStatus")}
                    options={props.appointmentStatusOptions}
                    search={true}
                    selection={true}
                    value={props.appointmentStatus}>
                  </Dropdown>
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardAppointmentSummaryUX-FormGroup-48"
              inline={true}>
              <FormField
                id="CardAppointmentSummaryUX-FormField-49"
                style={{display: "block"}}
                width="8">
                <label
                  id="CardAppointmentSummaryUX-label-59">
                  {props.languageUX === "en" ? "HN patient" : "HN ผู้ป่วย"}
                </label>
                <div
                  id="CardAppointmentSummaryUX-div-66">
                  {props.searchPatient}
                </div>
              </FormField>
              <FormField
                id="CardAppointmentSummaryUX-FormField-50"
                style={{display: "block"}}
                width="8">
                <div
                  id="CardAppointmentSummaryUX-div-81"
                  style={{display: "flex", justifyContent: "space-between"}}>
                  
                  <label
                    id="CardAppointmentSummaryUX-label-82"
                    style={{fontWeight: "bold"}}>
                    {props.languageUX === "en" ? "physician" : "แพทย์"}
                  </label>
                  <Checkbox
                    checked={props.isUnspecifiedDoctor}
                    disabled={!!props.providerDoctor}
                    id="CardAppointmentSummaryUX-Checkbox-83"
                    label=" ไม่ระบุ"
                    onChange={props.onChange("isUnspecifiedDoctor")}>
                  </Checkbox>
                </div>
                <div
                  id="CardAppointmentSummaryUX-div-67">
                  
                  <Dropdown
                    clearable={true}
                    disabled={props.isUnspecifiedDoctor}
                    fluid={true}
                    id="CardAppointmentSummaryUX-Dropdown-74"
                    onChange={props.onChange("providerDoctor")}
                    options={props.providerDoctorOptions}
                    selection={true}
                    value={props.providerDoctor}>
                  </Dropdown>
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardAppointmentSummaryUX-FormGroup-51"
              style={{display: "flex", alignItems: "flex-end"}}
              widths={true}>
              <FormField
                id="CardAppointmentSummaryUX-FormField-52"
                style={{display: "block"}}
                width="7">
                <label
                  id="CardAppointmentSummaryUX-label-61">
                  {props.languageUX === "en" ? "Appointment date" : "วันที่นัดหมาย"}
                </label>
                <div
                  id="CardAppointmentSummaryUX-div-68">
                  
                  <DateTextBox
                    id="CardAppointmentSummaryUX-DateTextBox-76"
                    onChange={props.onDateChange("startDate")}
                    value={props.startDate}>
                  </DateTextBox>
                </div>
              </FormField>
              <FormField
                id="CardAppointmentSummaryUX-FormField-79">
                <label
                  id="CardAppointmentSummaryUX-label-80">
                  {props.languageUX === "en" ? "to" : "ถึง"}
                </label>
              </FormField>
              <FormField
                id="CardAppointmentSummaryUX-FormField-53"
                style={{display: "block"}}
                width="7">
                <label
                  id="CardAppointmentSummaryUX-label-62">
                  
                </label>
                <div
                  id="CardAppointmentSummaryUX-div-69">
                  
                  <DateTextBox
                    id="CardAppointmentSummaryUX-DateTextBox-77"
                    onChange={props.onDateChange("endDate")}
                    value={props.endDate}>
                  </DateTextBox>
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardAppointmentSummaryUX-FormGroup-54"
              style={{display: "flex", alignItems: "flex-end"}}>
              <FormField
                id="CardAppointmentSummaryUX-FormField-55"
                style={{display: "block"}}
                width="8">
                <label
                  id="CardAppointmentSummaryUX-label-63">
                  {props.languageUX === "en" ? "Service status" : "สถานะรับบริการ"}
                </label>
                <div
                  id="CardAppointmentSummaryUX-div-70">
                  
                  <Dropdown
                    clearable={true}
                    fluid={true}
                    id="CardAppointmentSummaryUX-Dropdown-75"
                    onChange={props.onChange("orderStatus")}
                    options={props.orderStatusOptions}
                    selection={true}
                    value={props.orderStatus}>
                  </Dropdown>
                </div>
              </FormField>
              <FormField
                id="CardAppointmentSummaryUX-FormField-56"
                style={{display: "", paddingBottom: "5px"}}
                width="8">
                <Button
                  color="blue"
                  id="CardAppointmentSummaryUX-Button-84"
                  loading={props.loadingFilterAppList}
                  onClick={props.onSearch}
                  size="mini">
                  {props.languageUX === "en" ? "Search" : "ค้นหา"}
                </Button>
                <Button
                  color="orange"
                  id="CardAppointmentSummaryUX-Button-85"
                  onClick={props.onPrintAppointmentList}
                  size="mini">
                  {props.languageUX === "en" ? "Print list" : "พิมพ์รายชื่อ"}
                </Button>
              </FormField>
            </FormGroup>
          </div>
          <Table
            className="--rt-tbody-overflow-y-hidden"
            data={props.appointmentList || []}
            defaultPageSize="10"
            getTrProps={props.onGetPatientRow}
            headers=",HN,ชื่อ - สกุล,แพทย์"
            id="CardAppointmentSummaryUX-Table-5"
            keys="_icon,hn,patient_name,doctor_name"
            minRows="10"
            pageSize="10"
            showPagination={false}
            style={{height: "45vh"}}
            widths="60,">
          </Table>
          <div
            id="CardAppointmentSummaryUX-div-86"
            style={{display: "flex", justifyContent: "flex-end", padding: "5px"}}>
            {props.pagination}
          </div>
        </div>
        <div
          id="CardAppointmentSummaryUX-div-3"
          style={{flex: 3, display: props.tab ? "none": "",width:"70%"}}>
          
          <Calendar
            eventPropGetter={props.eventPropGetter}
            events={props.blockList}
            id="CardAppointmentSummaryUX-Calendar-1"
            localizer={props.localizer}
            onRangeChange={props.onRangeChange}
            onSelectEvent={props.onSelectEvent}>
          </Calendar>
        </div>
        <div
          id="CardAppointmentSummaryUX-div-99"
          style={{flex: 3, ...(['generalAppDetailUX', 'generalAppDateTimeUX'].includes(props.tab)? {} : {display: "none"}),width:"70%"}}>
          
          <div
            id="CardAppointmentSummaryUX-div-100"
            style={{display: "flex", alignItems: "center", padding: "10px 10px 0px 10px", justifyContent: "space-between"}}>
            
            <div
              id="CardAppointmentSummaryUX-div-101"
              style={{display: "flex", alignItems: "center"}}>
              
              <Button
                color={props.tab === "generalAppDetailUX"? "blue": ""}
                disabled={props.disabledBtnAppointment||false}
                id="CardAppointmentSummaryUX-Button-102"
                onClick={props.onChangeTab("generalAppDetailUX")}
                size="mini">
                {props.languageUX === "en" ? "Appointment details" : "รายละเอียดการนัดหมาย"}
              </Button>
              <Button
                color={props.tab === "generalAppDateTimeUX"? "blue": ""}
                disabled={props.disabledBtnSelectDatetime||false}
                id="CardAppointmentSummaryUX-Button-103"
                onClick={props.onChangeTab("generalAppDateTimeUX")}
                size="mini">
                {props.languageUX === "en" ? "Select appointment date and time" : "เลือกวันเวลานัดหมาย"}
              </Button>
            </div>
            <div
              id="CardAppointmentSummaryUX-div-104">
              
              <Button
                color="blue"
                id="CardAppointmentSummaryUX-Button-105"
                onClick={props.onHideDetail}
                size="mini">
                {props.languageUX === "en" ? "Hide details" : "ซ่อนรายละเอียด"}
              </Button>
            </div>
          </div>
          <hr
            id="CardAppointmentSummaryUX-hr-108">
          </hr>
          <div
            id="CardAppointmentSummaryUX-div-106"
            style={{display: props.tab === "generalAppDetailUX"? "": "none", height: "85vh", overflow: "auto"}}>
            {props.generalAppDetailUX}
          </div>
          <div
            id="CardAppointmentSummaryUX-div-107"
            style={{display: props.tab === "generalAppDateTimeUX"? "": "none", height: "80vh"}}>
            {props.generalAppDateTimeUX}
          </div>
        </div>
        <div
          id="CardAppointmentSummaryUX-div-87"
          style={{flex: 3, ...(['consultDetailUX', 'consultDateTimeUX'].includes(props.tab)? {} : {display: "none"}),width:"70%"}}>
          
          <div
            id="CardAppointmentSummaryUX-div-93"
            style={{display: "flex", alignItems: "center", padding: "10px 10px 0px 10px", justifyContent: "space-between"}}>
            
            <div
              id="CardAppointmentSummaryUX-div-94"
              style={{display: "flex", alignItems: "center"}}>
              
              <Button
                color={props.tab === "consultDetailUX"? "blue": ""}
                id="CardAppointmentSummaryUX-Button-95"
                onClick={props.onChangeTab("consultDetailUX")}
                size="mini">
                {props.languageUX === "en" ? "Consultation details" : "รายละเอียดการ Consult"}
              </Button>
              <Button
                color={props.tab === "consultDateTimeUX"? "blue": ""}
                disabled={props.disabledConsultDateTimeTab}
                id="CardAppointmentSummaryUX-Button-96"
                onClick={props.onChangeTab("consultDateTimeUX")}
                size="mini">
                {props.languageUX === "en" ? "Select appointment date and time" : "เลือกวันเวลานัดหมาย"}
              </Button>
            </div>
            <div
              id="CardAppointmentSummaryUX-div-97">
              
              <Button
                color="blue"
                id="CardAppointmentSummaryUX-Button-98"
                onClick={props.onHideDetail}
                size="mini">
                {props.languageUX === "en" ? "Hide details" : "ซ่อนรายละเอียด"}
              </Button>
            </div>
          </div>
          <hr
            id="CardAppointmentSummaryUX-hr-109">
          </hr>
          <div
            id="CardAppointmentSummaryUX-div-89"
            style={{display: props.tab === "consultDetailUX"? "": "none", height: "90vh"}}>
            {props.consultDetailUX}
          </div>
          <div
            id="CardAppointmentSummaryUX-div-92"
            style={{display: props.tab === "consultDateTimeUX"? "": "none", height: "90vh"}}>
            {props.consultDateTimeUX}
          </div>
        </div>
        <div
          id="CardAppointmentSummaryUX-div-110"
          style={{flex: 3, ...(['rehabDetailUX', 'rehabDateTimeUX'].includes(props.tab)? {} : {display: "none"}),width:"70%"}}>
          
          <div
            id="CardAppointmentSummaryUX-div-111"
            style={{display: "flex", alignItems: "center", padding: "10px 10px 0px 10px", justifyContent: "space-between"}}>
            
            <div
              id="CardAppointmentSummaryUX-div-112"
              style={{display: "flex", alignItems: "center"}}>
              
              <Button
                color={props.tab === "rehabDetailUX"? "blue": ""}
                id="CardAppointmentSummaryUX-Button-117"
                onClick={props.onChangeTab("rehabDetailUX")}
                size="mini">
                {props.languageUX === "en" ? "Treatment Plan" : "แผนการรักษา"}
              </Button>
              <Button
                color={props.tab === "rehabDateTimeUX"? "blue": ""}
                disabled={props.disabledRehabDateTimeTab}
                id="CardAppointmentSummaryUX-Button-118"
                onClick={props.onChangeTab("rehabDateTimeUX")}
                size="mini">
                {props.languageUX === "en" ? "Appointment date/time" : "วัน/เวลานัดหมาย"}
              </Button>
            </div>
            <div
              id="CardAppointmentSummaryUX-div-113">
              
              <Button
                color="blue"
                id="CardAppointmentSummaryUX-Button-119"
                onClick={props.onHideDetail}
                size="mini">
                {props.languageUX === "en" ? "Hide details" : "ซ่อนรายละเอียด"}
              </Button>
            </div>
          </div>
          <hr
            id="CardAppointmentSummaryUX-hr-116">
          </hr>
          <div
            id="CardAppointmentSummaryUX-div-114"
            style={{display: props.tab === "rehabDetailUX"? "": "none", padding: "0 0.5rem"}}>
            {props.rehabDetailUX}
          </div>
          <div
            id="CardAppointmentSummaryUX-div-115"
            style={{display: props.tab === "rehabDateTimeUX"? "": "none"}}>
            {props.rehabDateTimeUX}
          </div>
        </div>
      </div>
    )
}


export default CardAppointmentSummaryUX

export const screenPropsDefault = {}

/* Date Time : Wed Oct 01 2025 12:14:45 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{height: \"90vh\", display: \"flex\"}"
        }
      },
      "seq": 0
    },
    {
      "from": "react-big-calendar",
      "id": 1,
      "name": "Calendar",
      "parent": 3,
      "props": {
        "eventPropGetter": {
          "type": "code",
          "value": "props.eventPropGetter"
        },
        "events": {
          "type": "code",
          "value": "props.blockList"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-Calendar-1"
        },
        "localizer": {
          "type": "code",
          "value": "props.localizer"
        },
        "onRangeChange": {
          "type": "code",
          "value": "props.onRangeChange"
        },
        "onSelectEvent": {
          "type": "code",
          "value": "props.onSelectEvent"
        }
      },
      "seq": 1,
      "void": true
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{flex: 1, overflow: \"auto\"}"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{flex: 3, display: props.tab ? \"none\": \"\",width:\"70%\"}"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 5,
      "name": "Table",
      "parent": 2,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "data": {
          "type": "code",
          "value": "props.appointmentList || []"
        },
        "defaultPageSize": {
          "type": "value",
          "value": "10"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.onGetPatientRow"
        },
        "headers": {
          "type": "value",
          "value": ",HN,ชื่อ - สกุล,แพทย์"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-Table-5"
        },
        "keys": {
          "type": "value",
          "value": "_icon,hn,patient_name,doctor_name"
        },
        "minRows": {
          "type": "value",
          "value": "10"
        },
        "pageSize": {
          "type": "value",
          "value": "10"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"45vh\"}"
        },
        "widths": {
          "type": "value",
          "value": "60,"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": null,
      "id": 44,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-div-44"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 45,
      "name": "FormGroup",
      "parent": 44,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-FormGroup-45"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 46,
      "name": "FormField",
      "parent": 45,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-FormField-46"
        },
        "style": {
          "type": "code",
          "value": "{display: \"block\"}"
        },
        "width": {
          "type": "value",
          "value": "8"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 47,
      "name": "FormField",
      "parent": 45,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-FormField-47"
        },
        "style": {
          "type": "code",
          "value": "{display: \"block\"}"
        },
        "width": {
          "type": "value",
          "value": "8"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 48,
      "name": "FormGroup",
      "parent": 44,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-FormGroup-48"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 49,
      "name": "FormField",
      "parent": 48,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-FormField-49"
        },
        "style": {
          "type": "code",
          "value": "{display: \"block\"}"
        },
        "width": {
          "type": "value",
          "value": "8"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 50,
      "name": "FormField",
      "parent": 48,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-FormField-50"
        },
        "style": {
          "type": "code",
          "value": "{display: \"block\"}"
        },
        "width": {
          "type": "value",
          "value": "8"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 51,
      "name": "FormGroup",
      "parent": 44,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-FormGroup-51"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"flex-end\"}"
        },
        "widths": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 52,
      "name": "FormField",
      "parent": 51,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-FormField-52"
        },
        "style": {
          "type": "code",
          "value": "{display: \"block\"}"
        },
        "width": {
          "type": "value",
          "value": "7"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 53,
      "name": "FormField",
      "parent": 51,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-FormField-53"
        },
        "style": {
          "type": "code",
          "value": "{display: \"block\"}"
        },
        "width": {
          "type": "value",
          "value": "7"
        }
      },
      "seq": 79,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 54,
      "name": "FormGroup",
      "parent": 44,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-FormGroup-54"
        },
        "inline": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"flex-end\"}"
        },
        "widths": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 55,
      "name": "FormField",
      "parent": 54,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-FormField-55"
        },
        "style": {
          "type": "code",
          "value": "{display: \"block\"}"
        },
        "width": {
          "type": "value",
          "value": "8"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 56,
      "name": "FormField",
      "parent": 54,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-FormField-56"
        },
        "style": {
          "type": "code",
          "value": "{display: \"\", paddingBottom: \"5px\"}"
        },
        "width": {
          "type": "value",
          "value": "8"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": null,
      "id": 57,
      "name": "label",
      "parent": 46,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทนัดหมาย",
          "valueEN": "Appointment Type"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-label-57"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": null,
      "id": 58,
      "name": "label",
      "parent": 47,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะนัดหมาย",
          "valueEN": "Appointment status"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-label-58"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": null,
      "id": 59,
      "name": "label",
      "parent": 49,
      "props": {
        "children": {
          "type": "value",
          "value": "HN ผู้ป่วย",
          "valueEN": "HN patient"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-label-59"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": null,
      "id": 61,
      "name": "label",
      "parent": 52,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่นัดหมาย",
          "valueEN": "Appointment date"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-label-61"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": null,
      "id": 62,
      "name": "label",
      "parent": 53,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-label-62"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": null,
      "id": 63,
      "name": "label",
      "parent": 55,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะรับบริการ",
          "valueEN": "Service status"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-label-63"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": null,
      "id": 64,
      "name": "div",
      "parent": 46,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-div-64"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": null,
      "id": 65,
      "name": "div",
      "parent": 47,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-div-65"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": null,
      "id": 66,
      "name": "div",
      "parent": 49,
      "props": {
        "children": {
          "type": "code",
          "value": "props.searchPatient"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-div-66"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": null,
      "id": 67,
      "name": "div",
      "parent": 50,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-div-67"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": null,
      "id": 68,
      "name": "div",
      "parent": 52,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-div-68"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": null,
      "id": 69,
      "name": "div",
      "parent": 53,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-div-69"
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": null,
      "id": 70,
      "name": "div",
      "parent": 55,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-div-70"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 71,
      "name": "Dropdown",
      "parent": 64,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-Dropdown-71"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChange(\"appointmentType\")"
        },
        "options": {
          "type": "code",
          "value": "props.appointmentTypeOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.appointmentType"
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 72,
      "name": "Dropdown",
      "parent": 65,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-Dropdown-72"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChange(\"appointmentStatus\")"
        },
        "options": {
          "type": "code",
          "value": "props.appointmentStatusOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.appointmentStatus"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 74,
      "name": "Dropdown",
      "parent": 67,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.isUnspecifiedDoctor"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-Dropdown-74"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChange(\"providerDoctor\")"
        },
        "options": {
          "type": "code",
          "value": "props.providerDoctorOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.providerDoctor"
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 75,
      "name": "Dropdown",
      "parent": 70,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-Dropdown-75"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChange(\"orderStatus\")"
        },
        "options": {
          "type": "code",
          "value": "props.orderStatusOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.orderStatus"
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 76,
      "name": "DateTextBox",
      "parent": 68,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-DateTextBox-76"
        },
        "onChange": {
          "type": "code",
          "value": "props.onDateChange(\"startDate\")"
        },
        "value": {
          "type": "code",
          "value": "props.startDate"
        }
      },
      "seq": 76,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 77,
      "name": "DateTextBox",
      "parent": 69,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-DateTextBox-77"
        },
        "onChange": {
          "type": "code",
          "value": "props.onDateChange(\"endDate\")"
        },
        "value": {
          "type": "code",
          "value": "props.endDate"
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 79,
      "name": "FormField",
      "parent": 51,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-FormField-79"
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": null,
      "id": 80,
      "name": "label",
      "parent": 79,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึง",
          "valueEN": "to"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-label-80"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": null,
      "id": 81,
      "name": "div",
      "parent": 50,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-div-81"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": null,
      "id": 82,
      "name": "label",
      "parent": 81,
      "props": {
        "children": {
          "type": "value",
          "value": "แพทย์",
          "valueEN": "physician"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-label-82"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 83,
      "name": "Checkbox",
      "parent": 81,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.isUnspecifiedDoctor"
        },
        "disabled": {
          "type": "code",
          "value": "!!props.providerDoctor"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-Checkbox-83"
        },
        "label": {
          "type": "value",
          "value": " ไม่ระบุ"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChange(\"isUnspecifiedDoctor\")"
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 84,
      "name": "Button",
      "parent": 56,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหา",
          "valueEN": "Search"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-Button-84"
        },
        "loading": {
          "type": "code",
          "value": "props.loadingFilterAppList"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSearch"
        },
        "size": {
          "type": "value",
          "value": "mini"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 85,
      "name": "Button",
      "parent": 56,
      "props": {
        "children": {
          "type": "value",
          "value": "พิมพ์รายชื่อ",
          "valueEN": "Print list"
        },
        "color": {
          "type": "value",
          "value": "orange"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-Button-85"
        },
        "onClick": {
          "type": "code",
          "value": "props.onPrintAppointmentList"
        },
        "size": {
          "type": "value",
          "value": "mini"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": null,
      "id": 86,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "code",
          "value": "props.pagination"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-div-86"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", padding: \"5px\"}"
        }
      },
      "seq": 86,
      "void": false
    },
    {
      "from": null,
      "id": 87,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-div-87"
        },
        "style": {
          "type": "code",
          "value": "{flex: 3, ...(['consultDetailUX', 'consultDateTimeUX'].includes(props.tab)? {} : {display: \"none\"}),width:\"70%\"}"
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": null,
      "id": 89,
      "name": "div",
      "parent": 87,
      "props": {
        "children": {
          "type": "code",
          "value": "props.consultDetailUX"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-div-89"
        },
        "style": {
          "type": "code",
          "value": "{display: props.tab === \"consultDetailUX\"? \"\": \"none\", height: \"90vh\"}"
        }
      },
      "seq": 93,
      "void": false
    },
    {
      "from": null,
      "id": 92,
      "name": "div",
      "parent": 87,
      "props": {
        "children": {
          "type": "code",
          "value": "props.consultDateTimeUX"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-div-92"
        },
        "style": {
          "type": "code",
          "value": "{display: props.tab === \"consultDateTimeUX\"? \"\": \"none\", height: \"90vh\"}"
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": null,
      "id": 93,
      "name": "div",
      "parent": 87,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-div-93"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", padding: \"10px 10px 0px 10px\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": null,
      "id": 94,
      "name": "div",
      "parent": 93,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-div-94"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 95,
      "name": "Button",
      "parent": 94,
      "props": {
        "children": {
          "type": "value",
          "value": "รายละเอียดการ Consult",
          "valueEN": "Consultation details"
        },
        "color": {
          "type": "code",
          "value": "props.tab === \"consultDetailUX\"? \"blue\": \"\""
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-Button-95"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeTab(\"consultDetailUX\")"
        },
        "size": {
          "type": "value",
          "value": "mini"
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 96,
      "name": "Button",
      "parent": 94,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือกวันเวลานัดหมาย",
          "valueEN": "Select appointment date and time"
        },
        "color": {
          "type": "code",
          "value": "props.tab === \"consultDateTimeUX\"? \"blue\": \"\""
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledConsultDateTimeTab"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-Button-96"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeTab(\"consultDateTimeUX\")"
        },
        "size": {
          "type": "value",
          "value": "mini"
        }
      },
      "seq": 96,
      "void": false
    },
    {
      "from": null,
      "id": 97,
      "name": "div",
      "parent": 93,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-div-97"
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 98,
      "name": "Button",
      "parent": 97,
      "props": {
        "children": {
          "type": "value",
          "value": "ซ่อนรายละเอียด",
          "valueEN": "Hide details"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-Button-98"
        },
        "onClick": {
          "type": "code",
          "value": "props.onHideDetail"
        },
        "size": {
          "type": "value",
          "value": "mini"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": null,
      "id": 99,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-div-99"
        },
        "style": {
          "type": "code",
          "value": "{flex: 3, ...(['generalAppDetailUX', 'generalAppDateTimeUX'].includes(props.tab)? {} : {display: \"none\"}),width:\"70%\"}"
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": null,
      "id": 100,
      "name": "div",
      "parent": 99,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-div-100"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", padding: \"10px 10px 0px 10px\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": null,
      "id": 101,
      "name": "div",
      "parent": 100,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-div-101"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 102,
      "name": "Button",
      "parent": 101,
      "props": {
        "children": {
          "type": "value",
          "value": "รายละเอียดการนัดหมาย",
          "valueEN": "Appointment details"
        },
        "color": {
          "type": "code",
          "value": "props.tab === \"generalAppDetailUX\"? \"blue\": \"\""
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledBtnAppointment||false"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-Button-102"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeTab(\"generalAppDetailUX\")"
        },
        "size": {
          "type": "value",
          "value": "mini"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 103,
      "name": "Button",
      "parent": 101,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือกวันเวลานัดหมาย",
          "valueEN": "Select appointment date and time"
        },
        "color": {
          "type": "code",
          "value": "props.tab === \"generalAppDateTimeUX\"? \"blue\": \"\""
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledBtnSelectDatetime||false"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-Button-103"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeTab(\"generalAppDateTimeUX\")"
        },
        "size": {
          "type": "value",
          "value": "mini"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": null,
      "id": 104,
      "name": "div",
      "parent": 100,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-div-104"
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 105,
      "name": "Button",
      "parent": 104,
      "props": {
        "children": {
          "type": "value",
          "value": "ซ่อนรายละเอียด",
          "valueEN": "Hide details"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-Button-105"
        },
        "onClick": {
          "type": "code",
          "value": "props.onHideDetail"
        },
        "size": {
          "type": "value",
          "value": "mini"
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": null,
      "id": 106,
      "name": "div",
      "parent": 99,
      "props": {
        "children": {
          "type": "code",
          "value": "props.generalAppDetailUX"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-div-106"
        },
        "style": {
          "type": "code",
          "value": "{display: props.tab === \"generalAppDetailUX\"? \"\": \"none\", height: \"85vh\", overflow: \"auto\"}"
        }
      },
      "seq": 107,
      "void": false
    },
    {
      "from": null,
      "id": 107,
      "name": "div",
      "parent": 99,
      "props": {
        "children": {
          "type": "code",
          "value": "props.generalAppDateTimeUX"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-div-107"
        },
        "style": {
          "type": "code",
          "value": "{display: props.tab === \"generalAppDateTimeUX\"? \"\": \"none\", height: \"80vh\"}"
        }
      },
      "seq": 108,
      "void": false
    },
    {
      "from": null,
      "id": 108,
      "name": "hr",
      "parent": 99,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-hr-108"
        }
      },
      "seq": 106,
      "void": true
    },
    {
      "from": null,
      "id": 109,
      "name": "hr",
      "parent": 87,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-hr-109"
        }
      },
      "seq": 92,
      "void": true
    },
    {
      "from": null,
      "id": 110,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-div-110"
        },
        "style": {
          "type": "code",
          "value": "{flex: 3, ...(['rehabDetailUX', 'rehabDateTimeUX'].includes(props.tab)? {} : {display: \"none\"}),width:\"70%\"}"
        }
      },
      "seq": 110,
      "void": false
    },
    {
      "from": null,
      "id": 111,
      "name": "div",
      "parent": 110,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-div-111"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", padding: \"10px 10px 0px 10px\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 111,
      "void": false
    },
    {
      "from": null,
      "id": 112,
      "name": "div",
      "parent": 111,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-div-112"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 112,
      "void": false
    },
    {
      "from": null,
      "id": 113,
      "name": "div",
      "parent": 111,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-div-113"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 113,
      "void": false
    },
    {
      "from": null,
      "id": 114,
      "name": "div",
      "parent": 110,
      "props": {
        "children": {
          "type": "code",
          "value": "props.rehabDetailUX"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-div-114"
        },
        "style": {
          "type": "code",
          "value": "{display: props.tab === \"rehabDetailUX\"? \"\": \"none\", padding: \"0 0.5rem\"}"
        }
      },
      "seq": 115,
      "void": false
    },
    {
      "from": null,
      "id": 115,
      "name": "div",
      "parent": 110,
      "props": {
        "children": {
          "type": "code",
          "value": "props.rehabDateTimeUX"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-div-115"
        },
        "style": {
          "type": "code",
          "value": "{display: props.tab === \"rehabDateTimeUX\"? \"\": \"none\"}"
        }
      },
      "seq": 116,
      "void": false
    },
    {
      "from": null,
      "id": 116,
      "name": "hr",
      "parent": 110,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-hr-116"
        }
      },
      "seq": 114,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 117,
      "name": "Button",
      "parent": 112,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนการรักษา",
          "valueEN": "Treatment Plan"
        },
        "color": {
          "type": "code",
          "value": "props.tab === \"rehabDetailUX\"? \"blue\": \"\""
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-Button-117"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeTab(\"rehabDetailUX\")"
        },
        "size": {
          "type": "value",
          "value": "mini"
        }
      },
      "seq": 117,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 118,
      "name": "Button",
      "parent": 112,
      "props": {
        "children": {
          "type": "value",
          "value": "วัน/เวลานัดหมาย",
          "valueEN": "Appointment date/time"
        },
        "color": {
          "type": "code",
          "value": "props.tab === \"rehabDateTimeUX\"? \"blue\": \"\""
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledRehabDateTimeTab"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-Button-118"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeTab(\"rehabDateTimeUX\")"
        },
        "size": {
          "type": "value",
          "value": "mini"
        }
      },
      "seq": 118,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 119,
      "name": "Button",
      "parent": 113,
      "props": {
        "children": {
          "type": "value",
          "value": "ซ่อนรายละเอียด",
          "valueEN": "Hide details"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryUX-Button-119"
        },
        "onClick": {
          "type": "code",
          "value": "props.onHideDetail"
        },
        "size": {
          "type": "value",
          "value": "mini"
        }
      },
      "seq": 119,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardAppointmentSummaryUX",
  "project": "cudent2",
  "screenPropsDefault": {
  },
  "width": 85
}

*********************************************************************************** */
